import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/Home.vue';
import WritingsList from './components/Writings/WritingsList';
import WritingPage from './components/Writings/WritingPage';
import Dashboard from './components/Dashboard/Dashboard';
import Profile from './components/Dashboard/Profile';
import CreateWriting from './components/Dashboard/CreateWriting';
import UserWritings from './components/Dashboard/UserWritings';
import Users from './components/Dashboard/Users';
import AppAuth from './components/Auth/AppAuth';
import AppLogin from './components/Auth/AppLogin';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/writings',
      name: 'writings',
      component: WritingsList
    },
    {
      path: '/writings/:id',
      name: 'writing-page',
      component: WritingPage
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      redirect: '/dashboard/profile',
      children: [
        {
          path: 'profile',
          name: 'dashboard-profile',
          component: Profile
        },
        {
          path: 'send-writing',
          name: 'dashboard-writing',
          component: CreateWriting
        },
        {
          path: 'writings-list',
          name: 'dashboard-user-writings',
          component: UserWritings
        },
        {
          path: 'users',
          name: 'dashboard-users',
          component: Users
        }
      ]
    },
    {
      path: '/auth',
      name: 'authentication',
      redirect: '/auth/signin',
      component: AppAuth,
      children: [
        {
          path: 'signin',
          name: 'auth-signin',
          component: AppLogin
        }
      ]
    }
    // {
    //   path: '/about',
    //   name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    else {
      return { x: 0, y: 0 }
    }
  },
})
